<template>

    <section 
    :class="{ 'follow-me-consultancy': $route.name === 'consultoria' }" 
     class="follow-me p-0 pt-5 pb-5 d-flex flex-column flex-lg-row justify-content-center align-items-start">

        <div class="col-12 col-lg-3 d-flex flex-column justify-content-center align-items-center align-items-lg-start px-5">
            <h3 class="fs-5 mt-3 mt-lg-0">Quero um projeto</h3>
            <!--<router-link to="/formulario" class="mt-3">Solicitar orçamento</router-link>-->
            <a :href="whatsappLink()"  class="mt-3" target="_blank">Solicitar orçamento</a>
            <router-link to="/vagas" class="mt-3">Trabalhe conosco</router-link>
            <span class="mt-3">CAU nº A325216-7</span>

            <div class="mt-5 d-none d-lg-block">
                <a :href="affariDevLink()"  target="_blank">Desenvolvido por <strong>AFFARIDEV</strong></a>
            </div>
        </div>


        <div class="col-12 col-lg-3 m-0 mt-3 mt-md-0 d-flex flex-column justify-content-center align-items-center align-items-lg-start px-5">

            <h3 class="fs-5 mt-4 mt-lg-0">Informações de contato</h3>

            <div class="mt-3 d-flex justify-content-center flex-column align-items-start align-items-lg-start">
                <a :href="instagramLink()" target="_blank" class="rounded m-2 d-flex justify-content-center align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="m-1 bi bi-instagram" viewBox="0 0 16 16">
                        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                    </svg>
                    <span class="fs-6 m-1">@studioilia.arq</span>                
                </a>
                <a :href="whatsappLink()" target="_blank" class="rounded m-2 d-flex justify-content-center align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi bi-whatsapp" viewBox="0 0 16 16">
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                    </svg>
                    <span class="fs-6 m-1">(82) 99331-8909</span>                
                </a>
                 <a :href="emailLink()" target="_blank" class="rounded m-2 d-flex justify-content-center align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
                        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
                    </svg>
                    <span class="fs-6 m-1">studioilia.arq@gmail.com</span>                
                </a>
            </div> 

        </div>

        <div class="mt-4 mt-lg-0 col-12 col-lg-3 px-5 d-flex flex-column justify-content-center align-items-center align-items-lg-start">
            <h3 class="fs-5 mt-3 mt-lg-0">Localização</h3>
            <iframe class="col-12" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17735.944265208076!2d-35.728233826668884!3d-9.658276523293429!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x70145b9a2ab46c9%3A0x4c3e1fb6dd6a5a04!2zSmF0acO6Y2EsIE1hY2Vpw7MgLSBBTA!5e0!3m2!1spt-BR!2sbr!4v1770303205858!5m2!1spt-BR!2sbr"allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            <div class="mt-5 d-block d-lg-none">
                <a :href="affariDevLink()"  target="_blank">Desenvolvido por <strong>AFFARIDEV</strong></a>
            </div>
        </div>

        
        
    </section>
    
</template>

<script>
export default {
  name: 'Contacts',
  inject: ['affariDevLink', 'whatsappLink', 'instagramLink', 'emailLink'],

  data() {
    return {
       
    };
  },
  methods: {
   
  },
  mounted() {
  
  }
}
</script>

<style scoped>

.follow-me {
    background-color: var(--color-1);
}

.follow-me.follow-me-consultancy {
    background-color: var(--color-7);
}

.follow-me h3, 
.follow-me span {
    color: var(--color-7);
}

.follow-me-consultancy  h3, 
.follow-me-consultancy  span {
    color: var(--color-9);
}

.follow-me h3 {
    font-weight: bold;
}


.follow-me-consultancy  h3 {
    font-weight: bold;
}

.follow-me a {
    text-decoration: none;
    background-color: var(--color-1);
}
.follow-me-consultancy a {
    text-decoration: none;
    background-color: var(--color-7);
}

iframe {
    height: 300px;
}

.follow-me a {
  color: var(--color-7); 
}

.follow-me-consultancy a {
  color: var(--color-9); 
}

.follow-me a,
.follow-me strong {
    color: var(--color-7);
}

.follow-me-consultancy a,
.follow-me-consultancy strong {
    color: var(--color-9);
}

.follow-me a:hover, .follow-me strong:hover, .follow-me span:hover {
    color: var(--color-4);
    transition: 1s;
} 

.follow-me-consultancy a:hover, .follow-me-consultancy strong:hover, .follow-me-consultancy span:hover {
    color: var(--color-3);
    transition: 1s;
} 

</style>
